module.exports = __webpack_public_path__ + "img/commitment_info.3e55c283.svg";